import { FC, useState, useEffect, useContext } from "react";
import { useIntl } from "react-intl";
import { PageLink, PageTitle } from "../../../_metronic/layout/core";
import CustomerDataContext from "../../../store/CustomerData-context";
import { Link, useHistory } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import clsx from "clsx";
import * as Yup from "yup";
import { useFormik } from "formik";
import ErrorMessage1 from "../../components/ErrorMessage1";
import {
  addUserHandler,
  siteAccessOptions,
  menuAccessOptions,
} from "./userManagement-hooks";
import Alert1 from "../../components/Alert1";
// for grabbing loginRole
// import { shallowEqual, useSelector } from "react-redux";
// import { RootState } from "../../../setup";
import ConstantsContext from "../../../store/Constants-context";
import Cookies from "universal-cookie";
import { Breadcrumb } from "../../../_metronic/layout/components/header/Breadcrumb";
import "./UserManagement.css";
const cookies = new Cookies();
const initialValues = {
  fName: "",
  lName: "",
  cognitoEmail: "",
  cognitoUsername: "",
  site_admin: false,
  // mobile: "",
};

// Create a function to generate the validation schema based on SSO status
const createUserDetailsSchema = (isSSOEnabled: boolean) => {
  const baseSchema = {
    fName: Yup.string()
        .trim("Cannot include leading and trailing spaces")
        .min(1, "Minimum 1 character required.")
        .max(50, "Maximum 50 characters allowed.")
        .required("First name is required"),
    lName: Yup.string()
        .trim("Cannot include leading and trailing spaces")
        .min(1, "Minimum 1 character required.")
        .max(50, "Maximum 50 characters allowed.")
        .required("Last name is required"),
    cognitoEmail: Yup.string()
        .trim("Cannot include leading and trailing spaces")
        .email("Wrong email format")
        .min(3, "Minimum 3 characters required.")
        .max(50, "Maximum 50 characters required.")
        .required("Email is required"),
    cognitoUsername: Yup.string().when([], {
      is: () => !isSSOEnabled,
      then: (schema) => schema
          .trim()
          .min(1, "Minimum 1 character required.")
          .max(50, "Maximum 50 characters allowed.")
          .required("Username is required"),
      otherwise: (schema) => schema.notRequired()
    })
    // mobile: Yup.string()
    //   .trim("Cannot include leading and trailing spaces")
    //   .min(8, "Minimum 8 characters required.")
    //   .max(13, "Maximum 12 characters required."),
  };

  return Yup.object().shape(baseSchema);
};

const AddUser: FC = () => {
  const history = useHistory();

  // Add state to track SSO status
  const [isSSOEnabled, setIsSSOEnabled] = useState(false);

  // const loginRole = useSelector<RootState>(
  //   ({ auth }) => auth.loginRole,
  //   shallowEqual
  // ); // grabbing login role from redux
  cookies.get("site_admin") !== "1" && window.location.replace("/"); // this page is only accessible to site_admins

  const [menuAccess, setMenuAccess] = useState<
      { value: string; label: string }[]
  >([]);
  const [previousMenuAccess, setPreviousMenuAccess] = useState<
      { value: string; label: string }[]
  >([]);
  const [menuAccessError, setMenuAccessError] = useState(false);
  const [siteAccess, setSiteAccess] = useState<
      { value: string; label: string }[]
  >([]);
  const [previousSiteAccess, setPreviousSiteAccess] = useState<
      { value: string; label: string }[]
  >([]);
  const [siteAccessError, setSiteAccessError] = useState(false);
  const [disableSiteAccess, setDisableSiteAccess] = useState(false);
  const [disableMenuAccess, setDisableMenuAccess] = useState(false);
  const [siteAdmin, setSiteAdmin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const intl = useIntl();
  const customerCtx = useContext(CustomerDataContext);
  const constantsCtx = useContext(ConstantsContext);

  /*
  - true when external_provider is a non-empty, non-whitespace string.
  - false when external_provider is undefined, null, or an empty/whitespace string.
  */
  function getSsoStatus(externalProvider: string | undefined | null): boolean {
    return !!externalProvider && externalProvider.trim() !== '';
  }

  // Effect to determine SSO status
  useEffect(() => {
    setIsSSOEnabled(getSsoStatus((customerCtx.customer_data as any).external_provider));
  }, []);

  const formik = useFormik({
    initialValues,
    validationSchema: createUserDetailsSchema(isSSOEnabled),
    onSubmit: async (values) => {
      // If SSO is enabled, set username to email automatically
      const submitValues = isSSOEnabled
          ? { ...values, cognitoUsername: values.cognitoEmail }
          : values;

      await addUserHandler(
          submitValues,
          setLoading,
          menuAccess,
          siteAccess,
          setSuccess,
          setError,
          setErrorMsg,
          history
      );
    },
  });

  useEffect(() => {
    const siteAccessMultiSelectDropdown = document
        .getElementById("siteAccess")!
        .getElementsByClassName(
            "dropdown-container"
        ) as HTMLCollectionOf<HTMLElement>;
    const menuAccessMultiSelectDropdown = document
        .getElementById("menuAccess")!
        .getElementsByClassName(
            "dropdown-container"
        ) as HTMLCollectionOf<HTMLElement>;

    if (siteAdmin) {
      // Give all access to all sites
      customerCtx.sites.length > 0 && setSiteAccess(siteAccessOptions(customerCtx.sites));
      siteAccessMultiSelectDropdown[0].style.backgroundColor = "#f3f3f3";
      setDisableSiteAccess(true);
      setSiteAccessError(false);

      // Give all access to menu Options
      setMenuAccess(menuAccessOptions(customerCtx.menu_config));
      menuAccessMultiSelectDropdown[0].style.backgroundColor = "#f3f3f3";
      setDisableMenuAccess(true);
      // setMenuAccessError(false);
    } else {
      //Reset site access
      customerCtx.sites.length > 0 && setSiteAccess(previousSiteAccess);
      siteAccessMultiSelectDropdown[0].style.backgroundColor = "transparent";
      setDisableSiteAccess(false);
      //Reset menu access
      setMenuAccess(previousMenuAccess);
      menuAccessMultiSelectDropdown[0].style.backgroundColor = "transparent";
      setDisableMenuAccess(false);
    }
    // setMenuAccess(existingMenuOptions);
    // setMenuAccessError(false);
  }, [siteAdmin]);

  const addUserBreadCrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({ id: "MENU.SETUP" }),
      path: "/setup.html",
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({ id: "MENU.USERACCOUNTS" }),
      path: "/users",
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({ id: "MENU.ADDUSERACCOUNT" }),
      path: "/adduser",
      isSeparator: false,
      isActive: true,
    },
  ];

  return (
      <>
        <Breadcrumb
            pageBreadcrumbs={addUserBreadCrumbs}
            activePageName={"user_accounts"}
        />
        {/* Setting Active Page Name in the Context */}
        <PageTitle activePageName={"user_accounts"}></PageTitle>
        {/* begin::Row */}
        <div className="row gy-5 gx-xl-8">
          <div className="col-xxl-12">
            <div className="card card-custom">
              {/* end::Header */}
              <div className="card-header">
                <div className="card-title">
                  {intl.formatMessage({ id: "MENU.ADDUSERACCOUNT" })}
                </div>
              </div>
              <div className="card-body">
                <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      let foundErrors = false;
                      if (siteAccess.length === 0) {
                        setSiteAccessError(true);
                        foundErrors = true;
                      }
                      // if (menuAccess.length === 0) {
                      //   setMenuAccessError(true);
                      //   foundErrors = true;
                      // }
                      if (foundErrors === false) formik.handleSubmit();
                    }}
                >
                  <div className="row mb-10">
                    <div className="col-lg-6 col-xl-6">
                      <label className="col-lg-12 col-form-label">
                        First name <small style={{ color: "red" }}>*</small>
                      </label>
                      <input
                          type="text"
                          className={clsx(
                              "form-control form-control-solid px-5",
                              {
                                "is-invalid":
                                    formik.touched.fName && formik.errors.fName,
                              },
                              {
                                "is-valid":
                                    formik.touched.fName && !formik.errors.fName,
                              }
                          )}
                          {...formik.getFieldProps("fName")}
                      />
                      {formik.touched.fName && formik.errors.fName && (
                          <ErrorMessage1
                              color={constantsCtx.ERROR_MESSAGE_COLOR_RED}
                              errorMessage={formik.errors.fName}
                          />
                      )}
                    </div>

                    <div className="col-lg-6 col-xl-6">
                      <label className="col-lg-12 col-form-label">
                        Last name <small style={{ color: "red" }}>*</small>
                      </label>
                      <input
                          type="text"
                          className={clsx(
                              "form-control form-control-solid px-5",
                              {
                                "is-invalid":
                                    formik.touched.lName && formik.errors.lName,
                              },
                              {
                                "is-valid":
                                    formik.touched.lName && !formik.errors.lName,
                              }
                          )}
                          {...formik.getFieldProps("lName")}
                      />
                      {formik.touched.lName && formik.errors.lName && (
                          <ErrorMessage1
                              color={constantsCtx.ERROR_MESSAGE_COLOR_RED}
                              errorMessage={formik.errors.lName}
                          />
                      )}
                    </div>
                  </div>
                  <div className="row mb-10">
                    <div className={clsx(
                        isSSOEnabled ? "col-lg-6 col-xl-6" : "col-lg-6 col-xl-6"
                    )}>
                      <label className="col-lg-12 col-form-label">
                        Email <small style={{ color: "red" }}>*</small>
                      </label>
                      <input
                          type="email"
                          className={clsx(
                              "form-control form-control-solid px-5",
                              {
                                "is-invalid":
                                    formik.touched.cognitoEmail && formik.errors.cognitoEmail,
                              },
                              {
                                "is-valid":
                                    formik.touched.cognitoEmail && !formik.errors.cognitoEmail,
                              }
                          )}
                          {...formik.getFieldProps("cognitoEmail")}
                      />
                      {formik.touched.cognitoEmail && formik.errors.cognitoEmail && (
                          <ErrorMessage1
                              color={constantsCtx.ERROR_MESSAGE_COLOR_RED}
                              errorMessage={formik.errors.cognitoEmail}
                          />
                      )}
                    </div>

                    {/* Only show Username field if SSO is not enabled */}
                    {!isSSOEnabled && (
                        <div className="col-lg-6 col-xl-6">
                          <label className="col-lg-12 col-form-label">
                            Username <small style={{ color: "red" }}>*</small>
                          </label>
                          <input
                              type="text"
                              onFocus={(e) => {
                                formik.touched.cognitoEmail &&
                                !formik.errors.cognitoEmail &&
                                !formik.values.cognitoUsername &&
                                (e.target.value = formik.values.cognitoEmail) &&
                                (formik.values.cognitoUsername = formik.values.cognitoEmail);
                              }}
                              className={clsx(
                                  "form-control form-control-solid px-5",
                                  {
                                    "is-invalid":
                                        formik.touched.cognitoUsername && formik.errors.cognitoUsername,
                                  },
                                  {
                                    "is-valid":
                                        formik.touched.cognitoUsername && !formik.errors.cognitoUsername,
                                  }
                              )}
                              {...formik.getFieldProps("cognitoUsername")}
                          />
                          {formik.touched.cognitoUsername && formik.errors.cognitoUsername && (
                              <ErrorMessage1
                                  color={constantsCtx.ERROR_MESSAGE_COLOR_RED}
                                  errorMessage={formik.errors.cognitoUsername}
                              />
                          )}
                        </div>
                    )}
                  </div>

                  <div className="row mb-10">
                    <div className="col-lg-6 col-xl-6">
                      &nbsp;
                      {/*<label className="col-lg-12 col-form-label">*/}
                      {/*  Mobile*/}
                      {/*</label>*/}
                      {/*<input*/}
                      {/*  type="text"*/}
                      {/*  className={clsx(*/}
                      {/*    "form-control form-control-solid px-5",*/}
                      {/*    {*/}
                      {/*      "is-invalid":*/}
                      {/*        formik.touched.mobile && formik.errors.mobile,*/}
                      {/*    },*/}
                      {/*    {*/}
                      {/*      "is-valid":*/}
                      {/*        formik.touched.mobile && !formik.errors.mobile,*/}
                      {/*    }*/}
                      {/*  )}*/}
                      {/*  {...formik.getFieldProps("mobile")}*/}
                      {/*/>*/}
                      {/*{formik.touched.mobile && formik.errors.mobile && (*/}
                      {/*  <ErrorMessage1*/}
                      {/*    color={constantsCtx.ERROR_MESSAGE_COLOR_RED}*/}
                      {/*    errorMessage={formik.errors.mobile}*/}
                      {/*  />*/}
                      {/*)}*/}
                    </div>
                    <div className="col-lg-6 col-xl-6" id="menuAccess">
                      <label className="col-lg-12 col-form-label">
                        Menu Access Controls{" "}
                        {/*<small style={{ color: "red" }}>*</small>*/}
                      </label>
                      <MultiSelect
                          options={menuAccessOptions(customerCtx.menu_config)}
                          value={menuAccess}
                          disabled={disableMenuAccess}
                          hasSelectAll={true}
                          onChange={(e: any) => {
                            setMenuAccess(e);
                            // setMenuAccessError(false);
                            setPreviousMenuAccess(e);
                          }}
                          labelledBy="Select Menu Items"
                      />
                    </div>
                  </div>

                  <div className="row mb-10">
                    <div className="col-lg-4 col-xl-4">
                      <label className="form-check form-check-custom form-check-solid form-switch mb-5">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            {...formik.getFieldProps("site_admin")}
                            onClick={() => setSiteAdmin(!siteAdmin)}
                            checked={siteAdmin}
                        />
                        <span className="form-check-label col-form-label">
                        Site Administrator Access
                      </span>
                      </label>
                      <div className="d-flex p-1 mb-10" style={{ marginTop: "-2rem", marginLeft: "3.5rem"}}>
                        <div className="d-flex flex-column">
                          <span>Grants view/edit ability to all data, tools and settings</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 col-xl-2"></div>
                    <div className="col-lg-6 col-xl-6" id="siteAccess">
                      <label className="col-lg-12 col-form-label">
                        Site Access Controls{" "}
                        <small style={{ color: "red" }}>*</small>
                      </label>
                      <MultiSelect
                          options={siteAccessOptions(customerCtx.sites)}
                          value={siteAccess}
                          disabled={disableSiteAccess}
                          hasSelectAll={true}
                          onChange={(e: any) => {
                            setSiteAccess(e);
                            setSiteAccessError(false);
                            setPreviousSiteAccess(e);
                          }}
                          labelledBy="Select Sites"
                      />
                      {siteAccessError === true && (
                          <ErrorMessage1
                              color={constantsCtx.ERROR_MESSAGE_COLOR_RED}
                              errorMessage={"Please select at least one site"}
                          />
                      )}
                    </div>
                  </div>
                  <div className="row mb-10">
                    {/* begin::Saving Alert */}
                    {loading && (
                        <div className="alert alert-info d-flex align-items-center p-5 mb-10">
                          <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                          <div className="d-flex flex-column">
                            <h4 className="mb-1 text-info">Saving</h4>
                            <span>Please wait while we save the user information...</span>
                          </div>
                        </div>
                    )}
                    {/* end::Saving Alert */}

                    {/* begin::Success Alert */}
                    {!loading && success && (
                        <Alert1
                            alertTitle="Success"
                            alertMessage="User has been successfully added to the system!"
                            success={true}
                        />
                    )}
                    {/* end::Success Alert */}

                    {/* begin::Failure Alert */}
                    {!loading && error && (
                        <Alert1
                            alertTitle={"Failure"}
                            alertMessage={errorMsg}
                            success={false}
                        />
                    )}
                    {/* end::Failure Alert */}
                  </div>
                  <div className="row mb-10">
                    <div className="col-lg-6 col-xl-6">
                      <Link
                          className="btn btn-active-light btn-color-muted cancelButton"
                          to="/users"
                      >
                        Cancel
                      </Link>
                    </div>
                    <div className="col-lg-6 col-xl-6">
                      <button
                          type="submit"
                          className="btn btn-ll"
                          disabled={
                              formik.isSubmitting || !formik.isValid || success || loading
                          }
                      >
                        {!loading && (
                            <span className="indicator-label">Save</span>
                        )}
                        {loading && (
                            <span className="indicator-progress">
                          Saving...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
  );
};

export { AddUser };